import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import DashboardService from '@forwardflow/services/DashboardService'
import {
   AgentType,
   DashboardChartLeadSourceBreakdownParams,
   DashboardChartTeamPerformancePayload,
   TimePeriod,
} from '@forwardflow/types'
import useSWR from 'swr'

export const useGetDashboardData = () => {
   const response = useSWR(
      [QUERY_KEYS.DASHBOARD_DATA],
      DashboardService.getDashboardData
   )
   return {
      ...response,
   }
}

export const useGetDashboardChartsOverview = ({
   timePeriod,
}: {
   timePeriod: TimePeriod
}) => {
   const response = useSWR(
      [QUERY_KEYS.DASHBOARD_CHARTS_OVERVIEW, timePeriod],
      () => DashboardService.getDashboardChartsOverview(timePeriod)
   )
   return {
      ...response,
   }
}

export const useGetDashboardChartsLeadSource = ({
   timePeriod,
}: {
   timePeriod: TimePeriod
}) => {
   const response = useSWR(
      [QUERY_KEYS.DASHBOARD_CHARTS_LEAD_SOURCE, timePeriod],
      () => DashboardService.getDashboardChartsLeadSource(timePeriod)
   )
   return {
      ...response,
   }
}

// leadsource breakdown
export const useGetDashboardChartsLeadSourceBreakdown = (
   payload: DashboardChartLeadSourceBreakdownParams
) => {
   const response = useSWR(
      [
         QUERY_KEYS.DASHBOARD_CHARTS_LEAD_SOURCE_BREAKDOWN,
         ...Object.values(payload),
      ],
      () => DashboardService.getDashboardChartsLeadSourceBreakdown(payload)
   )
   return {
      ...response,
   }
}

export const useGetDashboardCommunication = ({
   timePeriod,
   agentType,
}: {
   timePeriod: TimePeriod
   agentType: AgentType
}) => {
   const response = useSWR(
      [QUERY_KEYS.DASHBOARD_CHARTS_COMMUNICATION, timePeriod, agentType],
      () =>
         DashboardService.getDashboardChartsCommunication({
            timePeriod,
            agentType,
         })
   )
   return {
      ...response,
   }
}

export const useGetDashboardChartsTeamPerformance = (
   payload: DashboardChartTeamPerformancePayload
) => {
   const response = useSWR(
      [QUERY_KEYS.DASHBOARD_CHARTS_TEAM_PERFORMANCE, payload],
      () => DashboardService.getDashboardChartsTeamPerformance(payload)
   )
   return {
      ...response,
   }
}
